export default function LoadingScreen() {
    return (
        <div className="flex items-center justify-center">
            <div
                style={{
                    width: "450px",
                    height: "570px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <img src="../loadingGif.gif" alt="Loading..." />
            </div>
        </div>
    );
} 
